<template>
  <v-container fluid>
    <v-container fluid class="app-container">
      <div v-if="loading">
        <px-circular-loading/>
      </div>
      <div>
        <px-criar-conta-nova-empresa-usuario hide-controls
                                             ref="formUser"
                                             :empresa="cadastro"/>
      </div>
      <div class="ml-3">
        <v-btn color="primary"
               :loading="loadingButton"
               :disabled="isInvalid"
               @click="enviar"
        >
          Enviar
        </v-btn>
      </div>
    </v-container>
  </v-container>
</template>

<script>
import { cloneDeep } from 'lodash';
import { onlyNumbers } from '@/utils/regex-utils';
import FornecedorService from '../fornecedor-service';
import CriarContaNovaEmpresaUsuario from '../usuario/CriarContaNovaEmpresaUsuario.vue';

export default {
  data() {
    return {
      loading: false,
      loadingButton: false,
      chave: this.$route.params.id,
      acesso: null,
      cadastro: {
        usuario: {
          nome: null,
          cpf: null,
          email: null,
          telefone: null,
          password: null,
          matchPassword: null,
        },
      },
      formUserRef: null,
    };
  },
  computed: {
    isInvalid() {
      return this.formUserRef && this.formUserRef.$v.$invalid;
    },
  },
  methods: {
    validarChave() {
      this.loading = true;
      FornecedorService.validarChave(this.chave)
        .then((response) => {
          this.acesso = response.data;
          if (!this.acesso.valido) {
            this.$toast('O link acessado não é mais válido, favor solicitar novo usário', { color: 'error' });
            this.$router.push({ name: 'login' });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildFornecedor() {
      const fornecedor = cloneDeep(this.cadastro);
      fornecedor.usuario.cpf = onlyNumbers(fornecedor.usuario.cpf);
      return fornecedor;
    },
    enviar() {
      this.loadingButton = true;
      FornecedorService.criarUser(this.acesso.fornecedor.id,
        this.chave,
        this.buildFornecedor())
        .then(() => {
          this.$toast('Seu usuário foi criado com sucesso', { color: 'success' });
          this.$router.push({ name: 'login' });
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
  },
  created() {
    this.validarChave();
  },
  mounted() {
    this.formUserRef = this.$refs.formUser;
  },
  components: {
    pxCriarContaNovaEmpresaUsuario: CriarContaNovaEmpresaUsuario,
  },
};
</script>
